import { ITranslatedString } from "libraries/interfaces/IContract";
import { ILanguageCodeValue } from "libraries/pipes/localized/localized.interface";
import { NameValueType } from "@afidium/ts-facade";

export interface IDashboardConfig {
    name: string;
    nameArray?: ILanguageCodeValue[];
    index: string;
    data: IDashboardConfigData[][];
    filters: IDashboardFilters;
    criteria: IDashboardFilters;

}

export interface IDashboardFilters {
    requestFile?: string;
    formFields: IDashboardFilterFormField[];
}

export interface IDashboardFilterFormField {
    type: string;
    code: string;
    titleArray: ITranslatedString[];
    placeholderArray?: ITranslatedString[];
    optionArray?: IOptionsWTranslatedString[];
}

export interface IOptionsWTranslatedString {
    value: string;
    labelArray: ITranslatedString[];
}

export enum EGraphType {
    LINE = 'line',
    BAR = 'bar',
    ROTATEBAR = 'rotatebar',
    SUNBURST = 'sunburst',
    NUMBER = 'number',
    MULTIPLE_BAR = 'multipleBar',
}

export enum EGraphClass {
    SIZES = 'sizeS',
    SIZEN = 'sizeN',
    SIZEL = 'sizeL',
}

export enum ENumberColType {
    NB = 'number',
    AT = 'amount',
}


export interface IDashboardConfigData {
    type: EGraphType;
    title?: string;
    titleArray?: NameValueType[];
    req?: string;
    xaxis?: string;
    xaxisArray?: NameValueType[];
    displayX?: boolean;
    yaxis?: string;
    yaxisArray?: NameValueType[];
    displayY?: boolean;
    "class"?: EGraphClass;
    index?: string;
    numberColumn?: INumberCol[];
}

export interface INumberCol {
    name?: string;
    key?: string;
    type: ENumberColType;
}

export interface IDashboardSearchParameter {
    [key: string]: string | Date | string[];
}

export interface ISearchParameterResponse {
    [key: string]: string;
}
